import { render, staticRenderFns } from "./cultural.vue?vue&type=template&id=7597f7e5&scoped=true"
import script from "./cultural.vue?vue&type=script&lang=js"
export * from "./cultural.vue?vue&type=script&lang=js"
import style0 from "./cultural.vue?vue&type=style&index=0&id=7597f7e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597f7e5",
  null
  
)

export default component.exports